exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/fleet-management/fleet-settings/fleet-settings.component.scss
// module id = ../../../../../src/app/fleet-management/fleet-settings/fleet-settings.component.scss
// module chunks = main